export const studyPhase = {
  "Bachelor year 1": "Bachelor year 1",
  "Bachelor year 2": "Bachelor year 2",
  "Bachelor year 3": "Bachelor year 3",
  "Pre-master": "Pre-master",
  Master: "Master",
  Exchange: "Exchange",
};
